import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NzButtonType} from "ng-zorro-antd/button/button.component";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

@Component({
  selector: 'fa-icon-btn',
  templateUrl: './icon-btn.component.html',
  styleUrls: ['./icon-btn.component.scss']
})
export class IconBtnComponent {

  @Input() buttonSize: string = "32";
  @Input() iconSize: string = "18";
  @Input() textSize: string = "14";

  @Input() nzType: NzButtonType = "default";
  @Input() nzDanger: boolean = false;
  @Input() icon: IconProp|null = null;

  @Input() opacity: string = '1';

  @Input() text: string = '';

  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() stopPropagation: boolean = false;

  @Output() btnClick = new EventEmitter();

  constructor() {

  }

  click(event: MouseEvent) {
    if (!this.loading && !this.disabled) this.btnClick.emit()
    if (this.stopPropagation) event.stopPropagation();
  }
}
